import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

export const useCookieBanner = (preferences: Record<string, unknown>) => {
  const { asPath, push } = useRouter()

  // Store the open/close state of the banner
  const [open, setOpen] = useState(false)

  // Store the CTA button that is pushed
  const [cta, setCTA] = useState<string | undefined>()

  // If the anchor #update-cookies is used, show the cookie consent notice banner
  useEffect(() => {
    const [url, hash] = asPath.split('#')
    if (hash === 'update-cookies') {
      setOpen(true)
      push(url, undefined, { shallow: true })
    }
  }, [asPath, push])

  const [prevConsent, setPrevConsent] = useState(preferences)

  // Send preference update to consent log API
  useEffect(() => {
    if (JSON.stringify(prevConsent) !== JSON.stringify(preferences)) {
      const postConsent = async () => {
        await fetch('/api/consent/log', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ cta, preferences }),
        })
      }
      postConsent().catch(console.error)

      setPrevConsent(preferences)
    }
    // Show consent banner only preferences are not set yet
    setOpen(Object.keys(preferences).length === 0)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preferences])

  return { open, setCTA }
}
